import { render, staticRenderFns } from "./copy_event_part.vue?vue&type=template&id=70b3104e&"
import script from "./copy_event_part.vue?vue&type=script&lang=js&"
export * from "./copy_event_part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports